import { EventFunction } from "@/types/common";
import Box from "@mui/material/Box";
import { SxProps } from "@mui/material/styles";
import { borderRadius } from "@/utils/borderRadius";
import { CSSProperties, ReactNode } from "react";
import { FlexRowAlignCenter } from "@/components/Flex";
import { themeColors } from "@/utils/themeColors";

type MiscProfileBoxProps = {
    className?: string;
    leftComponent: ReactNode;
    rightComponent?: ReactNode;
    style?: CSSProperties;
    onClick?: EventFunction;
    sx?: SxProps;
};

const MiscProfileBox = ({ className, leftComponent, rightComponent, style, onClick, sx }: MiscProfileBoxProps) => {
    return (
        <FlexRowAlignCenter
            as={Box}
            className={className}
            style={{
                height: "4.8rem",
                padding: "0 2rem",
                gap: "0.4rem",
                borderRadius: borderRadius.shortInput,
                cursor: onClick ? "pointer" : "normal",
                color: themeColors.neutralBlack,
                ...style,
            }}
            sx={{
                background: themeColors.background,
                "&:hover": {
                    boxShadow: onClick ? "inset 0 0 0 10em rgba(250, 250, 250, 0.14)" : null,
                },
                "&:active": { boxShadow: onClick ? "inset 0 0 0 10em rgba(250, 250, 250, 0.19)" : null },
                ...sx,
            }}
            onClick={onClick}>
            <span
                className="secondaryTextBold1"
                style={{
                    color: "inherit",
                }}>
                {leftComponent}
            </span>{" "}
            <span className="secondaryTextBold1" style={{ color: "inherit" }}>
                {rightComponent}
            </span>
        </FlexRowAlignCenter>
    );
};

export default MiscProfileBox;
